import React from "react";
import ApexCharts from "react-apexcharts";
import { Grid, Paper } from "@mui/material";

const StoreVsDepartmentChart = ({ data, onBarClick }) => {
  // const options = {
  //   chart: {
  //     type: "bar",
  //     stacked: true,
  //     events: {
  //       dataPointSelection: (
  //         event,
  //         chartContext,
  //         { dataPointIndex, seriesIndex }
  //       ) => {
  //         onBarClick(dataPointIndex, seriesIndex);
  //       },
  //     },
  //   },
  //   xaxis: { categories: data.categories },
  // };

  // return <ApexCharts options={options} series={data.series} type="bar" height={400} />;
  return (
    <Grid item xs={6}>
      <Paper elevation={3} sx={{ padding: "20px", height: 450 }}>
        <ApexCharts
          options={{
            title: {
              text: "Store vs Department",
            },
            tooltip: {
              text: "Shows department-wise product distribution in each store.",
            },
            chart: {
              type: "bar",
              stacked: true,
              events: {
                dataPointSelection: (
                  event,
                  chartContext,
                  { dataPointIndex, seriesIndex }
                ) => {
                  if (onBarClick) {
                    onBarClick(dataPointIndex, seriesIndex); // Notify the parent about the selected bar stack
                  }
                },
              },
            },
            xaxis: { categories: data.categories },
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 6, // Add rounded corners
                borderRadiusApplication: "end", // Apply to the end
                borderRadiusWhenStacked: "last", // Apply rounding to the last stacked bar
                dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: "13px",
                      fontWeight: 900,
                    },
                  },
                },
              },
            },
          }}
          series={data.series}
          type="bar"
          height={450}
        />
      </Paper>
    </Grid>
  );
};

export default StoreVsDepartmentChart;
